import React, {useState} from 'react';
import Popover from '@mui/material/Popover';
import IconButton from '@mui/material/IconButton';
import HelpIcon from '@mui/icons-material/Help';

const HelpPop = (props:{text:any})=>{
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'help-popover' : undefined;
	return (
		<>
		<IconButton onClick={handleClick} style={{margin:'0',padding:'0'}}><HelpIcon style={{verticalAlign:'middle',fontSize:'80%',marginBottom:'0.1em'}}/></IconButton>
		<Popover
			id={id}
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			>
			<div style={{padding:'1em',maxWidth:'300px',fontSize:'90%'}}>{props.text}</div>
		</Popover>
		</>
	)
}

export default HelpPop;